<template>
  <div class="UsuariosForm">
    <div v-if="isOnline">
      <md-card>
        <md-card-header>
          <div class="md-title">{{usuario.id ? 'Editar' : 'Registrar'}} usuario</div>
        </md-card-header>
        <md-card-content>
          <div class="md-layout md-gutter">
            <div :class="gridDefClass">
              <md-field :class="errores.nombre_usr">
                <label>Nombre</label>
                <md-input
                  v-model="usuario.nombre_usr"
                  required
                />
              </md-field>
            </div>
            <div :class="gridDefClass">
              <md-field :class="errores.ap_pat_usr">
                <label>Apellido paterno</label>
                <md-input
                  v-model="usuario.ap_pat_usr"
                  required
                />
              </md-field>
            </div>
            <div :class="gridDefClass">
              <md-field :class="errores.ap_mat_usr">
                <label>Apellido materno</label>
                <md-input v-model="usuario.ap_mat_usr" />
              </md-field>
            </div>
            <div :class="gridDefClass">
              <md-field :class="errores.tipo_usr">
                <label>Tipo</label>
                <md-select
                  v-model="usuario.tipo_usr"
                  md-dense
                  required
                >
                  <md-option value="administrativo">Administrativo</md-option>
                  <md-option value="medico">Médico</md-option>
                  <md-option value="otro">Otro</md-option>
                </md-select>
              </md-field>
            </div>
            <div
              :class="gridDefClass"
              v-if="usuario.tipo_usr==='medico'"
            >
              <md-field :class="errores.escuela_usr">
                <label>Escuela</label>
                <md-input v-model="usuario.escuela_usr" />
              </md-field>
            </div>
            <div
              :class="gridDefClass"
              v-if="usuario.tipo_usr==='medico'"
            >
              <md-field :class="errores.cedula_usr">
                <label>Cédula profesional</label>
                <md-input v-model="usuario.cedula_usr" />
              </md-field>
            </div>
            <div
              :class="gridDefClass"
              v-if="usuario.tipo_usr==='medico'"
            >
              <md-field :class="errores.rfc_usr">
                <label>R.F.C.</label>
                <md-input
                  v-model="usuario.rfc_usr"
                  maxlength="13"
                  required
                />
              </md-field>
            </div>
            <div
              :class="gridDefClass"
              v-if="usuario.tipo_usr==='medico'"
            >
              <md-field
                :class="errores.tel_usr"
                :md-counter="false"
              >
                <label>Teléfono</label>
                <md-input
                  v-model="usuario.tel_usr"
                  type="tel"
                  v-mask="'###-###-####'"
                  maxlength="14"
                  required
                />
              </md-field>
            </div>
            <div
              :class="gridDefClass"
              v-if="usuario.tipo_usr==='medico'"
            >
              <md-field :class="errores.mail_usr">
                <label>Correo electrónico</label>
                <md-input
                  type="email"
                  v-model="usuario.mail_usr"
                  required
                />
              </md-field>
            </div>
            <div
              :class="gridDefClass"
              v-if="usuario.tipo_usr==='medico'"
            >
              <md-datepicker
                v-model="usuario.fecha_ingreso_usr"
                :class="errores.fecha_ingreso_usr"
                md-immediately
              >
                <label>Fecha de ingreso*</label>
              </md-datepicker>
            </div>
            <div
              :class="gridDefClass"
              v-if="usuario.tipo_usr==='medico'"
            >
              <md-field :class="errores.id_ces_usr">
                <label>Jurisdicción de escuelas</label>
                <md-select
                  v-model="usuario.id_ces_usr"
                  md-dense
                  required
                >
                  <md-option
                    v-for="item in categorias_escuelas"
                    :key="item.id_ces"
                    :value="item.id_ces"
                  >
                    {{item.nombre_ces}}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div
              :class="gridDefClass"
              v-if="usuario.tipo_usr==='medico'"
            >
              <md-field :class="errores.jurisdiccion_usr">
                <label>Jurisdicción</label>
                <md-input
                  type="email"
                  v-model="usuario.jurisdiccion_usr"
                  required
                />
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div :class="gridDefClass">
              <md-field :class="errores.usuario_usr">
                <label>Usuario</label>
                <md-input
                  v-model="usuario.usuario_usr"
                  required
                />
              </md-field>
            </div>
            <div :class="gridDefClass">
              <md-field :class="errores.pass_usr">
                <label>Contraseña</label>
                <md-input
                  v-model="usuario.pass_usr"
                  type="password"
                  required
                />
              </md-field>
            </div>
            <div :class="gridDefClass">
              <md-field :class="errores.estatus_usr">
                <label>Estatus</label>
                <md-select
                  v-model="usuario.estatus_usr"
                  md-dense
                  required
                >
                  <md-option value="activo">Activo</md-option>
                  <md-option value="inactivo">Inactivo</md-option>
                </md-select>
              </md-field>
            </div>
          </div>
        </md-card-content>
        <md-card-actions>
          <md-button to="/usuarios">Cancelar</md-button>
          <md-button
            class="md-raised md-primary"
            @click="_presave"
          >{{usuario.id ? 'Actualizar' : 'Guardar'}}
          </md-button>
        </md-card-actions>
      </md-card>
      <Loading v-if="cargando" />
    </div>
    <InternetRequired v-else />
  </div>
</template>
<script>
import Loading from "@/components/Loading";
import InternetRequired from "@/components/InternetRequired";
export default {
  name: "UsuariosForm",
  components: {
    Loading,
    InternetRequired
  },
  methods: {
    _falloResponse(err) {
      this.cargando = false;
      if (err.status === 401) {
        this.$router.push("/login");
      } else {
        this.$emit("msg", this.$no_internet);
      }
    },
    _obtenerUsuario() {
      this.cargando = true;
      this.$http.get("usuario/" + this.$route.params.idUsr, this.$headers).then(
        res => {
          this.cargando = false;
          if (res.status === 401) {
            this.$router.push("/login");
          } else if (res.status === 200 && "usuario" in res.body) {
            this.usuario = res.body.usuario;
          } else {
            this.$emit("msg", res.body.error);
          }
        },
        err => this._falloResponse(err)
      );
    },
    _validar() {
      if (this.usuario.tipo_usr === "medico") {
        let fecha = this.$moment(this.usuario.fecha_ingreso_usr).format(
          "YYYY-MM-DD"
        );
        if (fecha != "Invalid date") {
          this.errores.fecha_ingreso_usr = this.$mdError(
            this.usuario.fecha_ingreso_usr
          );
        } else {
          this.errores.fecha_ingreso_usr = "md-invalid";
        }
        this.errores.rfc_usr = this.$mdError(this.usuario.rfc_usr);
        this.errores.tel_usr = this.$mdError(this.usuario.tel_usr);
        this.errores.mail_usr = this.$mdError(this.usuario.mail_usr);
        this.errores.cedula_usr = this.$mdError(this.usuario.cedula_usr);
        this.errores.jurisdiccion_usr = this.$mdError(
          this.usuario.jurisdiccion_usr
        );
      }
      this.errores.nombre_usr = this.$mdError(this.usuario.nombre_usr);
      this.errores.ap_pat_usr = this.$mdError(this.usuario.ap_pat_usr);
      this.errores.tipo_usr = this.$mdError(this.usuario.tipo_usr);
      this.errores.usuario_usr = this.$mdError(this.usuario.usuario_usr);
      this.errores.pass_usr = this.$mdError(this.usuario.pass_usr);
      this.errores.estatus_usr = this.$mdError(this.usuario.estatus_usr);
      return this.$validate(this.errores);
    },
    _presave() {
      if (this._validar()) {
        this.usuario.id ? this._actualizar() : this._guardar();
      } else {
        this.$emit("msg", this.$llene_campos);
      }
    },
    _guardar() {
      this.cargando = true;
      this.$http
        .post("usuarios", { usuario: this.usuario }, this.$headers)
        .then(
          res => {
            this.cargando = false;
            if (res.status === 401) {
              this.$router.push("/login");
            } else if (res.status === 201) {
              this.$emit("msg", "Usuario creado");
              this.$router.push("/usuarios");
            } else {
              this.$emit("msg", res.body.error);
            }
          },
          err => this._falloResponse(err)
        );
    },
    _actualizar() {
      this.cargando = true;
      this.$http
        .put(
          "usuario/" + this.usuario.id,
          {
            usuario: this.usuario
          },
          this.$headers
        )
        .then(
          res => {
            this.cargando = false;
            if (res.status === 401) {
              this.$router.push("/login");
            } else if (res.status === 200) {
              this.$emit("msg", "Usuario actualizado");
              this.$router.push("/usuarios");
            } else {
              this.$emit("msg", res.body.error);
            }
          },
          err => this._falloResponse(err)
        );
    },
    _getCategoriasEscuelas() {
      this.$http.get("categorias", this.$headers).then(
        res => {
          this.cargando = false;
          if (res.status === 401) {
            this.$router.push("/login");
          } else if (res.status === 200 && "categorias" in res.body) {
            this.categorias_escuelas = res.body.categorias;
          }
        },
        err => this._falloResponse(err)
      );
    }
  },
  data() {
    return {
      cargando: null,
      usuario: {
        id: null,
        id_usr: null,
        nombre_usr: null,
        ap_pat_usr: null,
        ap_mat_usr: null,
        tipo_usr: null,
        rfc_usr: null,
        fecha_ingreso_usr: null,
        jurisdiccion_usr: null,
        tel_usr: null,
        mail_usr: null,
        id_tutor_usr: null,
        escuela_usr: null,
        cedula_usr: null,
        usuario_usr: null,
        pass_usr: null,
        estatus_usr: null,
        notas_usr: null,
        id_ces_usr: null
      },
      errores: {
        id: null,
        id_usr: null,
        nombre_usr: null,
        ap_pat_usr: null,
        ap_mat_usr: null,
        tipo_usr: null,
        rfc_usr: null,
        fecha_ingreso_usr: null,
        jurisdiccion_usr: null,
        tel_usr: null,
        mail_usr: null,
        id_tutor_usr: null,
        escuela_usr: null,
        cedula_usr: null,
        usuario_usr: null,
        pass_usr: null,
        estatus_usr: null,
        notas_usr: null,
        id_ces_usr: null
      },
      gridDefClass: "md-layout-item md-xsmall-size-100 md-size-33",
      categorias_escuelas: []
    };
  },
  created() {
    this._getCategoriasEscuelas();
    if (this.$route.params.idUsr) {
      this._obtenerUsuario();
    }
  },
  beforeCreate() {
    if (!this.$session.exists() && !this.$session.get("tipo")) {
      this.$emit("visible", false);
      this.$router.push("/login");
    } else {
      this.$emit("visible", true);
      this.$emit("classes", "container");
    }
  }
};
</script>
